import { CircleMinus } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../ui/alert-dialog'
import { Button } from '../ui/button'
import { useBlockAndUnblockController } from './useBlockAndUnblockController'
import { Textarea } from '../ui/textarea'

type BlockAndUnBlockProps = {
  id: string
  isActive: boolean
}

export const BlockAndUnBlock = ({ id, isActive }: BlockAndUnBlockProps) => {
  const {
    disableIsPending,
    enableIsPending,
    handleDisableUser,
    handleEnableUser,
    handleBlockReason,
    textAreaValue,
    isTextAreaValid,
  } = useBlockAndUnblockController()

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <div className="flex h-11 w-full cursor-pointer items-center justify-center rounded-sm border-[1px] border-error bg-[#FFEDED]">
          <div className="flex items-center gap-2">
            <CircleMinus size={20} className="text-error" />
            <p className="text-error">
              {isActive ? 'Bloquear' : 'Desbloquear'}
            </p>
          </div>
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent className="w-96">
        <AlertDialogHeader>
          <AlertDialogTitle>
            Você quer realmente {isActive ? 'bloquear' : 'desbloquear'} esse
            usuário?
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          <p className="mb-2">Escreva uma justificativa para o bloqueio:</p>
          <Textarea
            onChange={(e) => handleBlockReason(e)}
            value={textAreaValue}
            className="resize-none text-black"
          />
          {!isTextAreaValid && textAreaValue.length > 0 && (
            <p className="mt-2 text-sm text-red-500">
              A justificativa deve ter pelo menos 5 caracteres.
            </p>
          )}
        </AlertDialogDescription>
        <AlertDialogFooter className="flex items-center">
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              type="submit"
              disabled={
                isActive
                  ? disableIsPending || !isTextAreaValid
                  : enableIsPending
              }
              onClick={
                isActive
                  ? () => handleDisableUser(id)
                  : () => handleEnableUser(id)
              }
              className="my-4 bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
            >
              {isActive ? 'Bloquear' : 'Desbloquear'}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
